import { Rating } from '@mui/material'
import React from 'react'

interface StarRatingProps {
  value: number
  classnames?: string
  type: number
  readOnly: boolean
  precision?: number
  setRating?: (value: number) => void
}

/**
 * Primary UI component for user interaction
 */
export const StarRating: React.FC<StarRatingProps> = ({
  value,
  classnames = '',
  type = 1,
  precision = 0.1,
  readOnly,
  setRating,
}) => {
  return (
    <Rating
      sx={{
        '& .MuiRating-iconFilled': {
          color: '#011d58',
        },
      }}
      defaultValue={0}
      precision={precision}
      value={value}
      readOnly={readOnly}
      size={type === 0 ? 'small' : type === 1 ? 'medium' : 'large'}
      className={classnames}
      onChange={(_: React.SyntheticEvent, value: number | null) => {
        !readOnly && setRating && setRating(value || 0)
      }}
    />
  )
}
